import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Play } from "lucide-react";

export const YoutubeCard = ({ youtubeId, title }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid={`gallery-video-${youtubeId}`}
        onClick={() => setOpen(true)}
        className="relative w-full aspect-video overflow-hidden border border-border group block"
      >
        <img
          src={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-colors">
          <div className="w-14 h-14 rounded-full bg-accent flex items-center justify-center">
            <Play className="h-6 w-6 text-accent-foreground" fill="currentColor" />
          </div>
        </div>
        <p className="absolute bottom-0 left-0 right-0 p-4 text-white text-sm font-medium bg-gradient-to-t from-black/70 to-transparent text-left">
          {title}
        </p>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden rounded-none border-border bg-black">
          <DialogTitle className="sr-only">{title}</DialogTitle>
          <div className="aspect-video">
            {open && (
              <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
